import { render, staticRenderFns } from "./NoticeSidebar.vue?vue&type=template&id=5ee89668&scoped=true&"
import script from "./NoticeSidebar.vue?vue&type=script&lang=js&"
export * from "./NoticeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NoticeSidebar.vue?vue&type=style&index=0&id=5ee89668&lang=scss&scoped=true&"
import style1 from "./NoticeSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee89668",
  null
  
)

export default component.exports